import Vue from 'vue'

//= lodash
import _ from 'lodash'
import VueLodash from 'vue-lodash'

import { en } from '@/assets/js/translations/common/En'
import { kr } from '@/assets/js/translations/common/Kr'
import { jp } from '@/assets/js/translations/common/Jp'
import { zh } from '@/assets/js/translations/common/Zh'

Vue.use(VueLodash, _)

export const common = _.merge(en, kr, jp, zh)
